export default {
	path: '/',
	redirect: {
		name: 'group-devices'
	}
};
